var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-component",class:_vm.$root.siteRenderer},[(_vm.isShowDevTool)?_c('DevTool'):_vm._e(),_c('MobileSideBar'),(_vm.isShowPageMask)?_c('div',{staticClass:"page-mask",on:{"click":_vm.toggleMenu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }